/**
 * Thin client-side wrapper for the Google Ads purchase conversion. The Google tag
 * (AW-18518340345) is already loaded sitewide in src/app/layout.tsx — this only fires
 * the conversion event.
 *
 * Fire ONLY for internal wallet orders (attempt.sitePurchaseEvent true, no Shopify order),
 * same condition as the Meta Purchase event — any order that exists in Shopify is reported
 * by Shopify's own Google & YouTube channel.
 *
 * No-op on the server or when the tag isn't loaded/blocked.
 */
type GtagWindow = Window & { gtag?: (...args: unknown[]) => void };

export function trackGoogleAdsPurchase(params: {
  value: number;
  currency: string;
  transactionId: string;
}) {
  if (typeof window === 'undefined') return;
  const gtag = (window as GtagWindow).gtag;
  if (typeof gtag !== 'function') return;
  try {
    gtag('event', 'conversion', {
      send_to: 'AW-18518340345/Bn3-CJGo5p8dEPnlnf5E',
      value: params.value,
      currency: params.currency,
      transaction_id: params.transactionId,
    });
  } catch {
    /* never let analytics break checkout */
  }
}
